import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Button, Box, Label } from 'fw/components';
import { ArrowCombo, Form } from 'fw/forms';
import * as Modals from 'fw/globals/Modals'

const items = {
	"1": "Ford",
	"2": "BMW",
	"3": "Porsche",
	"4": "Mercedes",
	"5": "VW",
	"6": "Ferrari",
	"7": "Peugeot",
	"8": "Lamborgini",
	"9": "Renault",
	"10": "Toyota"
};

class ArrowComboDemo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			form: {
				presetId: "2",
				presetName: "BMW"
			}
		};
	}

	onChange = (form, callback) => {
		this.setState({ form }, callback);
    }
    
	onSubmit = () => {
		Modals.alert(JSON.stringify(this.state.form));
	}

	render() {
		return (
			<Box title="Combo with arrows">
				<Form
					onChange={this.onChange}
					values={this.state.form}
					onSubmit={this.onSubmit}>
					<Row>
						<Col md={4}>
							<Label htmlFor="default">Default</Label>
							<ArrowCombo name="defaultId" label="defaultName" items={items} />
						</Col>
						<Col md={4}>
							<Label htmlFor="placeholder">Placeholder</Label>
							<ArrowCombo name="placeholderId" label="placeholderName" placeholder="ALL" items={items} />
						</Col>
						<Col md={4}>
							<Label htmlFor="disabled">Disabled</Label>
							<ArrowCombo name="disabledId" disabled={true} items={items} />
						</Col>
					</Row>
					<Row>
						<Col md={4}>
							<Label htmlFor="preset">Preset</Label>
							<ArrowCombo name="presetId" label="presetName" items={items} />
						</Col>
						<Col md={4}>
							<Label htmlFor="validationError" required>Required</Label>
							<ArrowCombo name="validationErrorId" label="validationErrorName" items={items} required />
						</Col>
						<Col md={4}>
							<Label htmlFor="nonSearchable">Non-Searchable</Label>
							<ArrowCombo name="nonSearchableId" label="nonSearchableName" items={items} searchable={false} />
						</Col>
					</Row>
					<Row>
						<Col md={4}>
							<Label htmlFor="Clearable">Clearable</Label>
							<ArrowCombo name="clearableId" label="clearableName" items={items} clearable={true} />
						</Col>
						<Col md={4}>
						</Col>
						<Col md={4}>
						</Col>
					</Row>
					<hr />
					<Button id="btnSubmit" type="submit" className="pull-right">Submit</Button>
				</Form>
			</Box>
		)
	}
}

export default ArrowComboDemo;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/DropDowns/ArrowComboDemo.js